import { sentry } from 'common/helpers'
import actions from 'redux/actions'


const get = (tokenName) => actions.models.requestTokens.get(tokenName)

const _update = (tokenName, value) => {
  actions.models.requestTokens.update({
    [tokenName]: value,
  })
}

const set = (opts, body, statusCode) => {
  if (opts.tokenName && body) {
    const sendException = statusCode < 500 && ![ 400, 401 ].includes(statusCode)

    if (body.token) {
      _update(opts.tokenName, body.token)
    }
    else if (sendException) {
      const { tokenName, method, endpoint } = opts || {}

      sentry.captureException(`Token "${tokenName}" required for "${method.toUpperCase()} ${endpoint}"`)
    }
  }
}


export default {
  get,
  set,
}
